import { render, staticRenderFns } from "./CreatePro.vue?vue&type=template&id=f29fe134&scoped=true"
import script from "./CreatePro.vue?vue&type=script&lang=js"
export * from "./CreatePro.vue?vue&type=script&lang=js"
import style0 from "./CreatePro.vue?vue&type=style&index=0&id=f29fe134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29fe134",
  null
  
)

export default component.exports